class CarouselProducts {
  constructor(selector, sex) {
    this.selector = selector;
    this.sex = sex;
    this.target = document.querySelector(`#${selector}`);
    this.arrContent = document.getElementsByClassName(selector);
    this.arrDom = [];
    this.arrTags = ["All"];
    this.carouselOpt = {
      cellAlign: "left",
      draggable: true,
      prevNextButtons: false,
      pageDots: false,
      watchCSS: true,
      contain: true,
    };
    this.filterTags.bind(this);
    window.addEventListener("DOMContentLoaded", this.pushArr.bind(this));
    window.addEventListener(
      "DOMContentLoaded",
      this.restartCarousel.bind(this)
    );
    window.addEventListener("DOMContentLoaded", this.displayTags.bind(this));
  }

  pushArr() {
    var arr;
    for (let i = 0; i < this.arrContent.length; i++) {
      this.arrDom.push(this.arrContent[i].outerHTML);
      if (this.arrContent[i].dataset.collection_type.includes(",")) {
        arr = this.arrContent[i].dataset.collection_type.split(",");
        for (let j = 0; j < arr.length; j++) {
          if (!this.arrTags.includes(arr[j])) {
            this.arrTags.push(arr[j]);
          }
        }
      } else {
        this.arrTags.push(this.arrContent[i].dataset.collection_type);
      }
    }
  }

  filterTags() {
    this.arrTags = this.arrTags.filter((value, index) => {
      return this.arrTags.indexOf(value) == index;
    });
  }

  filterDom(text) {
    let arrFilterDom = this.arrDom.filter((value) => {
      return value.indexOf(`${text}`) !== -1;
    });
    return arrFilterDom;
  }

  restartCarousel() {
    if (
      this.selector != "Ranking-Product_Mens" &&
      this.selector != "Ranking-Product_Ladies"
    ) {
      let flkty = new Flickity(this.target, this.carouselOpt);

      document
        .querySelector(`[data-NP-mw="${this.sex}"]`)
        .querySelectorAll("[data-NP-tag]")
        .forEach((value) =>
          value.addEventListener("click", () => {
            const dataNP = value.getAttribute("data-NP-tag");
            flkty.destroy();

            if (dataNP !== "All") {
              this.target.innerHTML = this.filterDom(dataNP).join("");
              flkty = new Flickity(this.target, this.carouselOpt);
            } else {
              this.target.innerHTML = this.arrDom.join("");
              flkty = new Flickity(this.target, this.carouselOpt);
            }
          })
        );
    } else {
      document
        .querySelector(`[data-Ranking-mw="${this.sex}"]`)
        .querySelectorAll("[data-Ranking-tag]")
        .forEach((value) =>
          value.addEventListener("click", () => {
            const dataRanking = value.getAttribute("data-Ranking-tag");
            if (dataRanking !== "All") {
              this.target.innerHTML = this.filterDom(dataRanking).join("");
            } else {
              this.target.innerHTML = this.arrDom.join("");
            }
          })
        );
    }
  }

  displayTags() {
    this.filterTags(this.arrTags);
    if (
      this.selector != "Ranking-Product_Mens" &&
      this.selector != "Ranking-Product_Ladies"
    ) {
      document
        .querySelector(`[data-NP-mw="${this.sex}"]`)
        .querySelectorAll("[data-NP-tag]")
        .forEach((value) => {
          const dataNP = value.getAttribute("data-NP-tag");
          if (!this.arrTags.includes(dataNP)) {
            value.classList.add("hidden");
          }
          value.addEventListener("click", () => {
            document
              .querySelector(`[data-NP-mw="${this.sex}"] .active`)
              .classList.remove("active");
            value.classList.add("active");

            document
              .querySelectorAll("a.new-product-view-all")
              .forEach((view_all_link) => {
                view_all_link.href =
                  "https://aoki-global.com/collections/" +
                  value.getAttribute("data-collection-handle") +
                  "?sort_by=created-descending";
              });
          });
        });
    } else {
      document
        .querySelector(`[data-Ranking-mw="${this.sex}"]`)
        .querySelectorAll("[data-Ranking-tag]")
        .forEach((value) => {
          const dataRanking = value.getAttribute("data-Ranking-tag");
          if (!this.arrTags.includes(dataRanking)) {
            value.classList.add("hidden");
          }
          value.addEventListener("click", () => {
            document
              .querySelector(`[data-Ranking-mw="${this.sex}"] .active`)
              .classList.remove("active");
            value.classList.add("active");
          });
        });
    }
  }
}

const CarouselNPWomen = new CarouselProducts("New-Product_Ladies", "women");
const CarouselNPMen = new CarouselProducts("New-Product_Mens", "men");
// const CarouselRankingWomen = new CarouselProducts("Ranking-Product_Ladies", "women")
// const CarouselRankingMen = new CarouselProducts("Ranking-Product_Mens", "men")

window.addEventListener("load", {
  CarouselNPWomen,
  CarouselNPMen,
  // CarouselRankingWomen,
  // CarouselRankingMen
});
